import React from 'react';
import SquareActionButton from 'src/common-ui/components/Buttons/SquareActionButton';
import './_GridErrorBoundary.scss';
import ServiceContainer from 'src/ServiceContainer';

interface GridErrorBoundaryState {
  hasError: boolean;
}

interface GridErrorBoundaryProps {
  children: React.ReactElement[] | React.ReactElement;
  errorTitle?: string;
  errorMessage?: string;
}

class GridErrorBoundary extends React.Component<GridErrorBoundaryProps, GridErrorBoundaryState> {
  constructor(props: GridErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  private static defaultProps = {
    errorTitle: 'Something went wrong with the application.',
    errorMessage:
      'If this continues to happen, let support know about the issue. You may refresh the page and try again:',
  };

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });

    window.console.error(error, info);
    ServiceContainer.loggingService.error('An error occurred in the grid', error.stack);
  }

  private retryClick = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      const { errorTitle, errorMessage } = this.props;
      return (
        <div className="error-display">
          <h1 className="error-title">{errorTitle}</h1>
          <p>{errorMessage}</p>
          <SquareActionButton text="Refresh" onClick={this.retryClick} />
        </div>
      );
    }
    return this.props.children;
  }
}

export default GridErrorBoundary;
